// those plans are default. gonna be override after fetching from server
export default [
    {
        id: 1,
        name: 'Weekly',
        price: 1095,
        additional_price: 2900,
        interval: 'week',
        quota: 500000000,
        status: {
            soon: false,
            hot: false,
        },
    },
    {
        id: 2,
        name: 'Basic',
        price: 3799,
        additional_price: 2900,
        interval: 'month',
        quota: 2000000000,
        status: {
            soon: false,
            hot: true,
        },
    },
    {
        id: 3,
        name: 'Premium',
        price: 9999,
        additional_price: 2000,
        interval: 'month',
        quota: 5000000000,
        status: {
            soon: false,
            hot: false,
        },
    },
    {
        id: 4,
        name: 'Reseller',
        price: 22999,
        additional_price: 1500,
        interval: 'month',
        quota: 10000000000,
        status: {
            soon: false,
            hot: false,
        },
    },
]